export type ScrollDirection = "up" | "down" | null;

export interface CategoryBarScrollState {
  lastY: number;
  direction: ScrollDirection;
  accumulated: number;
  visible: boolean;
}

export const CATEGORY_BAR_TOP_LIMIT = 20;
export const CATEGORY_BAR_JITTER_LIMIT = 4;
export const CATEGORY_BAR_HIDE_THRESHOLD = 28;
export const CATEGORY_BAR_SHOW_THRESHOLD = 16;

export const createCategoryBarScrollState = (scrollY = 0): CategoryBarScrollState => ({
  lastY: Math.max(scrollY, 0),
  direction: null,
  accumulated: 0,
  visible: true,
});

export const updateCategoryBarScrollState = (
  state: CategoryBarScrollState,
  scrollY: number,
  isHome: boolean,
): CategoryBarScrollState => {
  const nextY = Math.max(scrollY, 0);
  const delta = nextY - state.lastY;

  if (!isHome || nextY <= CATEGORY_BAR_TOP_LIMIT) {
    return { lastY: nextY, direction: null, accumulated: 0, visible: true };
  }

  if (Math.abs(delta) < CATEGORY_BAR_JITTER_LIMIT) {
    return { ...state, lastY: nextY };
  }

  const nextDirection: Exclude<ScrollDirection, null> = delta > 0 ? "down" : "up";
  const accumulated = state.direction === nextDirection
    ? state.accumulated + Math.abs(delta)
    : Math.abs(delta);
  let visible = state.visible;
  if (nextDirection === "down" && accumulated >= CATEGORY_BAR_HIDE_THRESHOLD) visible = false;
  if (nextDirection === "up" && accumulated >= CATEGORY_BAR_SHOW_THRESHOLD) visible = true;

  return { lastY: nextY, direction: nextDirection, accumulated, visible };
};
